import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseServiceFacade,
  GenericApiCall,
} from '../../../../common/store/types';
import { AppState } from '../../types';
import { KnownIpAddressFormModel, KnownIpAddressModel } from './types';
import { knownIpAddressActions } from './known-ip-address.actions';
import { knownIpAddressSelectors } from './known-ip-address.selector';

@Injectable()
export class KnownIpAddressService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<KnownIpAddressModel, number> = this.genericApiCall(
    knownIpAddressActions.getById,
    knownIpAddressSelectors.getById,
    true,
  );
  update: GenericApiCall<KnownIpAddressModel, KnownIpAddressFormModel> =
    this.genericApiCall(
      knownIpAddressActions.update,
      knownIpAddressSelectors.update,
      true,
    );
}
